import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AbstractEditActionButton } from '@connect-services/client/components/abstract-edit-action-button/abstract-edit-action-button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-add-entity-button',
    templateUrl: './add-entity-button.component.html',
})
export class AddEntityButtonComponent extends AbstractEditActionButton {
    public readonly customTooltipKey = input<string | undefined>();
    public readonly isActive = input<boolean>(false);

    protected resolveTooltip(): string | null {
        const customKey = this.customTooltipKey();
        if (customKey) {
            return customKey;
        }

        if (!this.hasPermission()) {
            return 'insufficientPermissions';
        }

        if (!this.isEditable()) {
            return 'editMode.layerStandardNotEditable';
        }

        return this.layerEditConfig()?.addEntityTooltipKey ?? null;
    }
}
